/**
 * The SyncGroupsApplyMode controls how many SyncGroups can be updated in the SyncState for one
 * run of rootProductOntoSyncState.
 *
 * "Fast" will update any SyncGroup that should be updated before running syncStateOntoRootProduct
 * This way several SyncGroups can be applied in one go before sending the validation calls to the * server, making the whole process faster.
 *
 * The downside of this is that is not exactly how CET (the desktop software) works. CET will
 * instead apply Features to the SyncState as soon as it gets the chance.
 *
 * "Strict" tries to behave exactly as CET. This will potentially generate a lot more validate
 * calls, increasing delay and cost.
 *
 * Strict is the safer option of the two, but we still recommend trying out Fast since it should
 * work fine in most cases.
 */
export var SyncGroupsApplyMode;
(function (SyncGroupsApplyMode) {
    SyncGroupsApplyMode["Strict"] = "Strict";
    SyncGroupsApplyMode["Fast"] = "Fast";
})(SyncGroupsApplyMode || (SyncGroupsApplyMode = {}));
